import { Box, Text } from "@chakra-ui/react";
import ArrivalRatesPerHourTable from "../../tables/daily/ArrivalRatesPerHourTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../../store/reportEnterpriseInsights";

const BranchArrivalRatesPerHour = ({ data }) => {
  return (
    <Box>
      {data.map((data, index) => {
        const { branchName, numServices } = data;
        const title = `${index + 1}. ${branchName}`;
        const insights = buildArrivalInsights(data, { scopeLabel: "Branch" });
        
        return (
          <Box key={index}>
            <h2>{title}</h2>
            <Text>{numServices} services</Text>
            <EnterpriseReportSummary
              title="Daily Hourly Arrival Demand Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            <ArrivalRatesPerHourTable
              data={data}
              index={index}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default BranchArrivalRatesPerHour;
